import {$} from '../util';

export default {
  view: function() {
    var $miniContacts = $(".mini-maps-contact__item");
    var expandedTitle = "Térkép bezárása";
    var closedTitle = "Térkép megnyitása";

    $miniContacts.each(function() {
      $(this)
        .find(".mini-maps-contact__map-button")
        .click(function() {
          var $button = $(this);
          var $thisMap = $button
            .parent()
            .parent()
            .find(".mini-maps-contact__map");

          $thisMap.toggleClass("mini-maps-contact__map--visible");
          var expanded = $thisMap.hasClass("mini-maps-contact__map--visible");

          $button.toggleClass("md-icnpre-map-pin-dot")
            .toggleClass("md-icnpre-close")
            .attr('title', expanded ? expandedTitle : closedTitle)
            .attr('aria-expanded', expanded);


          $(".mini-maps-contact__map")
            .not($thisMap)
            .removeClass("mini-maps-contact__map--visible");
          $(".mini-maps-contact__map-button")
            .not($button)
            .removeClass("md-icnpre-close")
            .addClass("md-icnpre-map-pin-dot")
            .attr('title', closedTitle)
            .attr('aria-expanded', false);
          ;
        }).attr('title', closedTitle).attr('aria-expanded', false);
    });
  }
};
